import type { TeamMember } from '@/api/types'
import { teamRoleRank } from '@/domain/words'

// 팀의 멤버 순서와 사용자 팀 화면의 멤버 줄. 순서는 관리자의 팀 화면(표)과 사용자의 팀 화면(줄)이 같이 쓰므로 여기 한 곳에만 있다 —
// 화면마다 적으면 한 화면만 바뀌어 같은 팀이 두 화면에서 다른 순서로 선다.

/** 관리자가 먼저다 — 이 목록을 보는 이유의 하나가 누구에게 말해야 하는가이기 때문이다. 같은 자리 안에서는 아이디순. */
export const byTeamRole = (a: TeamMember, b: TeamMember) =>
  teamRoleRank(a.role) - teamRoleRank(b.role) || a.username.localeCompare(b.username)

export const MEMBER_ROW = 'flex flex-wrap items-center gap-x-3 gap-y-1.5 border-b py-2 last:border-b-0'
